/* tslint:disable */
/* eslint-disable */
export enum ProjectBonusSettingFieldType {
  Empty = 1,
  Logical = 2,
  Selectable = 3,
}